import { render, staticRenderFns } from "./MyIconCard.vue?vue&type=template&id=e620a590&scoped=true&"
import script from "./MyIconCard.vue?vue&type=script&lang=js&"
export * from "./MyIconCard.vue?vue&type=script&lang=js&"
import style0 from "./MyIconCard.vue?vue&type=style&index=0&id=e620a590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e620a590",
  null
  
)

export default component.exports